<template>
  <div class="card">
    <div 
      v-if="title" 
      class="card-header">
      {{ title }}
    </div>

    <div class="card-body">
      <slot/>
    </div>
  </div>
</template>

<script>
	export default {
		name: 'Card',

		props: {
			title: {type: String, default: null}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Card.vue